import { apiFetch } from "#lib/api";
import { IApprovedDM } from "#entities/dms";
import dayjs from "dayjs";

export async function fetchProfileDMs(service: string, creatorId: string) {
  let dms = await apiFetch<IApprovedDM[]>(`/${service}/user/${creatorId}/dms`);
  return dms.map((dm) => {
    dm.added && (dm.added = dayjs(dm.added));
    dm.published && (dm.published = dayjs(dm.published));
    return dm;
  });
}
